import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';

export const StormwaterSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const text = report.testFitAnalysis?.stormwaterDetention;
  return (
    <SectionShell label={label} hasData={!!text}>
      {text && <p>{text}</p>}
    </SectionShell>
  );
};
